var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKucoin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13556_12402)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_13556_12402)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 52C40.3594 52 52 40.3594 52 26C52 11.6406 40.3594 0 26 0C11.6406 0 0 11.6406 0 26C0 40.3594 11.6406 52 26 52Z",
    fill: "#23AF91"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9375 26L30.3875 34.6124L35.75 29.25C36.725 28.275 38.1875 28.275 39 29.25C39.975 30.225 39.975 31.85 39 32.825L32.0125 39.975C31.0375 40.95 29.575 40.95 28.6 39.975L18.525 29.575V35.75C18.525 37.05 17.3875 38.1875 16.0875 38.1875C14.7875 38.1875 13.65 37.05 13.65 35.75V16.25C13.65 14.95 14.7875 13.8125 16.0875 13.8125C17.3875 13.8125 18.525 14.95 18.525 16.25V22.425L28.6 12.025C29.575 11.05 31.0375 11.05 32.0125 12.025L39 19.175C39.975 20.15 39.975 21.775 39 22.75C38.025 23.725 36.5625 23.725 35.75 22.75L30.3875 17.225L21.9375 26ZM30.3875 23.5625C31.6875 23.5625 32.825 24.7 32.825 26C32.825 27.3 31.6875 28.4375 30.3875 28.4375C29.0875 28.4375 27.95 27.3 27.95 26C27.95 24.7 29.0875 23.5625 30.3875 23.5625Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13556_12402"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_13556_12402"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKucoin);
export default __webpack_public_path__ + "static/media/Kucoin.077e5fe6d0574799520141a35c70294a.svg";
export { ForwardRef as ReactComponent };